module.exports = __webpack_public_path__ + "img/avatar-md.f02cdad7.svg";